module.exports = __webpack_public_path__ + "78e7608e89bc29186360c4b79e91a171.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/red_eradicated.png
 ** module id = 1076
 ** module chunks = 0
 **/